import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-minus-outline',
  templateUrl: './icon-account-minus-outline.component.html',
  styleUrl: './icon-account-minus-outline.component.scss',
  standalone: false,
})
export class IconAccountMinusOutlineComponent {
  @Input() tooltip?: string;
}

